const NavegacaoTelas = {
	namespaced: true,
	state: {
		barraLateralAberta: false,
	},
	mutations: {
		toggleBarraLateralAberta(state){
			state.barraLateralAberta = !state.barraLateralAberta;
		},
		changeBarraLateral(state, value){
			state.barraLateralAberta = value;
		},
		closeBarraLateral(state){
			state.barraLateralAberta = false;
		},
	},
	actions: {},
	getters: {
		getBarraLateralAberta: (state) => (state.barraLateralAberta),
	},
};

export default NavegacaoTelas;
